import vars from '@/vars'

(function($){
  $.fn.extend({
    sizer: function(){
      var h = $(window).height();
      var ih = window.innerHeight;
      var w = $(window).width();
      var ratio = w / h;
      var contH = ih - 50;

    },

    touchHover: function(){
      var start = "touchstart";
      var end = "touchend";
      var hoverTarget = $("a, .post, label, .root-list dl");

      hoverTarget.live(start, function() {
        $(this).addClass("touch");
      });
      hoverTarget.live(end, function() {
        $(this).removeClass("touch");
      });
    },

    anchor: function(){
      $("[data-anchor-link]").on('tap', function(){
        var alink = $(this).attr("data-anchor-link");
        var pos = $("[data-anchor="+ alink +"]").offset().top;
        var speed;
        if( $("html").is(".android") ){
          speed = 0;
        } else{
          speed = 600;
        }

        $('html,body').animate({ scrollTop: pos - 20 }, speed);
      });
    },

    toggleSwitch: function(){
      $(this).live('tap', function(){
        var $t = $(this);
        var target = $t.data("toggle-switch");
        $("[data-toggle-cont='"+ target +"']").not(":animated").slideToggle(300, function(){
          $t.toggleClass("active");
        });
      });
    },

    autoCurrenter: function(){
      var thisURL = location.href.split(location.host)[1];
      $("li", this).each(function(){
        var href = $("a", this).attr("href");
        if(href === thisURL){
          $(this).addClass("current");
        }
      });
    },

    toggleGroup: function(){
      return this.each(function(){
        var $that = $(this);
        $("[data-toggle-btn]", $that).on('tap', function(){
          var $t = $(this);
          var target = $t.data("toggle-btn");

          if( $t.hasClass("active") ){
            $("[data-toggle-cont='"+ target +"']", $that).slideUp(300, function(){
              $t.removeClass("active");
            });

          } else{
            $("[data-toggle-btn]", $that).removeClass("active");
            $t.addClass("active");

            $("[data-toggle-cont]", $that).each(function(){
              var data = $(this).data("toggle-cont");

              if( data === target ){
                $(this).slideDown(300);

                if(target === "pin"){
                  $(".map-category .cat-list").masonry();
                }
              }

              else{
                $(this).slideUp(300);
              }
            });
          }
        });
      });

    },

    uaCheck: function(){
      // use class jquery.ua.js
      // var is_sp = ".iphone, .ipod, .ipad, .android, .windowsphone";
      // var is_pc = ".win, .mac, .linux";

      if( $("html").is(vars.uaset.sp) ){
        $("html").addClass("ua-sp");
      } else {
        $("html").addClass("ua-pc");
      }
    },

    breakPoint: function(){
      var w = $(window).width();
      if(w > vars.break){
        $("html").attr("data-mode", "pc");
      } else{
        $("html").attr("data-mode", "sp");
      }
    },

    resBranch: function(options){
      var defaults = {
        pc: function(){},
        sp: function(){},
        tb: function(){}
      };
      options = $.extend(defaults, options);

      $(function(){
        if( $("html").is("[data-mode='pc']") ){
          defaults.pc();
        } else if( $("html").is("[data-mode='sp']") ){
          defaults.sp();
        } else if( $("html").is("[data-mode='tb']") ){
          defaults.tb();
        }
      });

      $(window).on('load resize orientationchange', function(){
        if( $("html").is("[data-mode='pc']") ){
          defaults.pc();
        } else if( $("html").is("[data-mode='sp']") ){
          defaults.sp();
        } else if( $("html").is("[data-mode='tb']") ){
          defaults.tb();
        }
      });
    }


  });

  $(function(){
    $.fn.touchHover();
    $.fn.uaCheck();
    $.fn.sizer();
    $.fn.breakPoint();
    $.fn.anchor();
  });

  $(window).on('ready load resize scroll', function(){
    $.fn.touchHover();
    $.fn.breakPoint();
    $.fn.sizer();
  });

})(jQuery);



// WEBPACK FOOTER //
// ./_src/js/init/extend.js